import Route from 'cio/routes/base';
import { action } from '@ember/object';
import Transition from '@ember/routing/-private/transition';
import ImportController from 'cio/pods/imports/import/index/controller';

export default class ImportingRoute extends Route {
  crumb() {
    return {
      name: 'Importing',
      path: this.routeName,
    };
  }

  @action
  willTransition(transition: Transition) {
    if (transition.to.name === 'imports.import.index') {
      let importController = this.controllerFor('imports.import.index') as ImportController;

      importController.set('isNewImport', true);
    }
  }
}
